import "../css/style.scss";

// Our modules / classes
// import MobileMenu from "./modules/MobileMenu";
//import LikeAxios from "./modules/Like_axios";
import Like from "./modules/Like";

// Instantiate a new object using our modules/classes
// const mobileMenu = new MobileMenu();
const like = new Like();

//alert("jjj007b");
